export const BASE_PATH_URL = process.env.REACT_APP_CALL_WRAP_SERVICE_BASE_PATH;

export const ACCESS_TOKEN_QUERY_PARAM_NAME = "o"
export const VIEW_DEMO_QUERY_PARAM_NAME = "viewDemo"
export const CONVERSATION_TYPE_QUERY_PARAM = 'conversationType'
export const INCLUDE_CALL_SCORE_QUERY_PARAM = 'includeCallScore'
export const CONVERSATION_TYPES = {
    GENERAL: 'general',
    SALES: 'sales'
}
export const INCLUDE_CALL_SCORE_TYPES = {
    TRUE: 'true',
    FALSE: 'false'
}

export const TokenExpiredErrorMessage = "Unable to fetch meetings because of invalid access token. Please regenerate and use the fresh access token."
export const MeetingsLoadingErrorMessage = "Unable to fetch meetings at the moment. Please try again after sometime."
export const MeetingNotFoundForConversationIdErrorMessage = "Unable to fetch the meeting details of the provided conversation ID"
export const MeetingsNotFoundErrorMessage = "No Meetings found for the user."
export const MeetingHasErrorsErrorMessage = "This meeting encountered errors while processing."
export const UnauthenticatedUserErrorMessage = "User is not authenticated to fetch the data"
export const promptErrorMessage = "Couldn't fetch the answer for the question"
export const transcriptionErrorMessage = "Transcription could not be fetched for conversation"
export const recordingUrlCannotBeLoadedForAudioPlayer = "Audio player couldn't be shown. Failed to load this conversation's recording url";
export const recordingUrlNotPresentForAudioPlayer = "Audio player couldn't be shown. Recording url not found for this conversation."

export const MEETING_LIST_ORDER = {
    ASCENDING: 'asc',
    DESCENDING: 'desc'
}


export const CALL_SUMMARY_FORMAT = {
    BULLET_LIST: {
        key: 'bulletPoints',
        name: 'Bullet List'
    },
    PARAGRAPH: {
        key: 'paragraphs',
        name: 'Paragraph'
    }
}

export const CALL_SUMMARY_LENGTH = {
    SHORT: {
        key: "smallSummary",
        name: 'Short',
    },
    MEDIUM: {
        key: "mediumSummary",
        name: 'Medium'
    },
    LONG: {
        key: 'longSummary',
        name: 'Long'
    }
}

export const POSITIVE_POLARITY_LIMIT = 0.3;
export const NEGATIVE_POLARITY_LIMIT = -0.3;
export const SENTIMENT_CHART_TOOLTIP_WIDTH = 420;

export const salesPrompts = ["What are the key takeaways from this sales call?",
    "What areas of improvement were identified in this call?",
    "How did the client respond to our proposal in this call?",
    "What product or service features resonated most with the client in this call?",
    "What are the action items and next steps from this sales interaction?",
    "What objections were raised in this call and how were they addressed?",
    "What strategies were most effective in this sales conversation?"
]
export const generalPrompts = ["What topics were discussed?",
    "What decisions were made?",
    "How could this conversation be made more productive?",
    "Why was the conversation sentiment positive/negative?"
]

export const NA_SCORE = 'n/a';
export const ERROR_DATA_NOT_FOUND = {
    EXECUTIVE_SUMMARY: "Summary not found for the conversation.",
    SUMMARY: "Summary not found for the conversation.",
    NEXT_STEPS: "Next steps not found for the conversation.",
    CALL_OBJECTIONS: "Objections not found for the conversation.",
    CALL_QUESTIONS_AND_ANSWERS: "Questions and answers not found for the conversation.",
    CALL_SCORE: "Call score not available for the conversation."
}

const LOG_PREFIX = '[Insights UI]';
export const USER_EVENTS = {
    VIEWED_MEETING_DETAILS_PAGE: `${LOG_PREFIX} Viewed meeting details page`,
    VIEWED_MEETING_LIST_PAGE: `${LOG_PREFIX} Viewed meeting list page`,
    HOVERED_SENTIMENT_GRAPH: `${LOG_PREFIX} Hovered over call sentiment graph`,
    CLICKED_SCORE_CARD: `${LOG_PREFIX} Clicked on call score card to view details`,
    CLICKED_PROMPT: `${LOG_PREFIX} Clicked on suggested prompt`,
    CLICKED_SUMMARY_LENGTH: `${LOG_PREFIX} Clicked to view summary length`,
    CLICKED_SUMMARY_FORMAT: `${LOG_PREFIX} Clicked to view summary format`,
}

export const SHOW_BACK_BUTTON = process.env.REACT_APP_SHOW_BACK_TO_LIST_PAGE_NAVIGATION_BUTTON === 'true';
export const SHOW_SHARE_BUTTON = process.env.REACT_APP_SHOW_SHARE_URL_BUTTON === 'true';
export const SHOW_SYMBL_BANNER = process.env.REACT_APP_SHOW_SYMBL_BANNER === 'true';
